<template>
  <div id="app">
    <v-app>
      <toolbar/>
      <nav-drawer v-if="apiToken && role"/>
      <v-content class="mt-5">
        <v-container fill-height class="align-center">
          <v-dialog
            v-model="sessionErr"
            width="400"
          >
            <v-card>
              <v-card-title class="headline grey lighten-2">
                Sesión expirada
              </v-card-title>
              <v-card-text>
                No podemos mostrar la información solicitada porque la sesión ha expirado. <br>
                Por favor vuelva a iniciar sesión.
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                dark
                  color="light-green darken-1"
                  @click="closeAlert"
                >
                  Aceptar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <router-view/>
        </v-container>
      </v-content>
    </v-app>
  </div>
</template>
<script>
import navDrawer from '@/shared/NavDrawer.vue';
import toolbar from '@/shared/Toolbar.vue';


export default {
  components: {
    toolbar,
    navDrawer,
  },
  computed: {
    reservas() {
      return this.$store.state.reservas;
    },
    sessionErr() {
      return this.$store.state.sessionErr;
    },
    apiToken() {
      return this.$store.state.sessionData.api_token;
    },
    role() {
      return this.$store.state.sessionData.role;
    },
  },
  methods: {
    closeAlert() {
      this.$store.dispatch('goBackToLogin', 'signOut');
    },
  },
  async created() {
    try {
      this.$store.dispatch('setSession');
      this.$store.dispatch('setSession');
      // console.log('sessionData', this.$store.state.sessionData);
      await this.$store.dispatch('setCabins', 'http://aplicacion.colinadelmanzano.com.ar/api/public/api/cabanas');
      // console.log('cabins', this.$store.state.cabins);
      await this.$store.dispatch('setReservas', 'http://aplicacion.colinadelmanzano.com.ar/api/public/api/reservas');
      // console.log('reservas', this.$store.state.reservas);
      this.$store.dispatch('setCalendar');
      // console.log('calendar', this.$store.state.calendar);
      for (let i = 0; i < this.reservas.length; i += 1) {
        // console.log(this.reservas[i]);
        this.$store.dispatch('setDays', {
          arrival: this.reservas[i].reservation_data.arrival,
          cabin: this.reservas[i].reservation_data.cabin,
          totalDays: this.reservas[i].reservation_data.days,
          id: this.reservas[i].id,
          name: this.reservas[i].reservation_data.name,
          breakfast: this.reservas[i].reservation_data.breakfast,
          guests: this.reservas[i].reservation_data.guests,
          origin: this.reservas[i].reservation_data.origin,
        });
      }
      this.$store.commit('setLoadedCalendar');
    } catch (e) {
      throw new Error(e);
    }
  },
};
</script>
<style lang="scss">
  @import '@/styles/main.scss';
</style>
